//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import GlobalMetrics from "./GlobalMetrics";
import {BButton, BCollapse} from 'bootstrap-vue'
import TimeSeries from "@/components/metrics/TimeSeries";
import PerformanceMetrics from "@/components/metrics/PerformanceMetrics";

export default {
  name: "Metrics",
  components: {
    PerformanceMetrics,
    TimeSeries,
    GlobalMetrics,
    BCollapse,
    BButton
  },
  props: {
    model: {
      type: Object,
      value: undefined,
    },
  },
  computed: {
    outputs() {
      if (this.model && this.model.contextParameters && this.model.contextParameters.performance) {
        let outputs = ['All'];
        return outputs.concat(this.model.contextParameters.performance.outputs.map((output) => output.name));
      }
      return [];
    },
  },
  data() {
    return {
      selectedOutput: 'All',
    };
  },
  methods: {
    setSelectedOutput(output) {
      this.selectedOutput = output;
    },
    hasPerfMetrics(model) {
      return model && model.contextParameters && model.contextParameters.performance;
    },
    isSelected(out) {
      return this.selectedOutput === null || this.selectedOutput === out;
    },
  },
};
